


















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";

@Component
export default class NumberSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  disabled: boolean;

  @Prop()
  total: number;

  @Prop({ default: false })
  isIndex: boolean;

  @Prop({ default: false })
  isHorizontal: boolean;

  toNumber(source: number): number {
    return this.isIndex
      ? (source - 1)
      : source;
  }

  get className(): string {
    return this.isHorizontal ? "horizontal-page-selector-root" : "";
  }

  get isPreviousPageMovable(): boolean {
    const currentPage = this.editingSource as number;
    return !this.disabled && isFinite(currentPage) && (currentPage > this.toNumber(1));
  }

  get isNextPageMovable(): boolean {
    const currentPage = this.editingSource as number;
    return !this.disabled && isFinite(currentPage) && (currentPage < this.toNumber(this.total));
  }

  moveToPrevPage(): boolean {
    if (!this.isPreviousPageMovable) { return; }
    this.editingSource = this.editingSource - 1;
  }

  moveToNextPage(): boolean {
    if (!this.isNextPageMovable) { return; }
    this.editingSource = this.editingSource + 1;
  }
}
